import React from 'react'

const Icon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={36} {...props}>
    <path
      d="M256 42.67L69.33 149.33v213.34L256 469.33l186.67-106.66V149.33L256 42.67z"
      fill="#fff"
    ></path>
    <path
      d="M256 59.12l172.27 98.44v196.88L256 452.88 83.73 354.44V157.56L256 59.12M256 0L32 128v256l224 128 224-128V128L256 0z"
      fill="#9da1a6"
    ></path>
    <path d="M256 128l-112 64v128l112 64 112-64V192l-112-64z" fill="#8b8f95"></path>
    <path d="M144 192v128l112 64V249.33z" fill="#6f747b"></path>
  </svg>
)

export default Icon
